function a(o, r) {
  var t = o(),
    n = new Set();
  return {
    getSnapshot: function getSnapshot() {
      return t;
    },
    subscribe: function subscribe(e) {
      return n.add(e), function () {
        return n.delete(e);
      };
    },
    dispatch: function dispatch(e) {
      var _r$e;
      for (var _len = arguments.length, s = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        s[_key - 1] = arguments[_key];
      }
      var i = (_r$e = r[e]).call.apply(_r$e, [t].concat(s));
      i && (t = i, n.forEach(function (c) {
        return c();
      }));
    }
  };
}
export { a as createStore };